import { useEffect, useState } from 'react';
import { getCachedTeamTags, loadTeamTags, subscribeTeamTags } from '../lib/teamTags';

// Map<user_id, tag> of everyone with a team tag (048). Shared module cache, so
// a feed of fifty posts makes one request, not fifty.
export function useTeamTags() {
  const [tags, setTags] = useState(getCachedTeamTags);
  useEffect(() => {
    const unsubscribe = subscribeTeamTags(setTags);
    loadTeamTags().then(setTags);
    return unsubscribe;
  }, []);
  return tags;
}

export default useTeamTags;
